import React, { Component } from 'react';
import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import no_sm_intro from 'assets/sounds/no/intros/NonWOrdInstruction.mp3';
import nn_sm_intro from 'assets/sounds/no/intros/NonWOrdInstruction.mp3';


class IntroNonwords extends Component {
	 constructor(props) {
		super(props);
		this.audio = strings.getLanguage() === 'nn' ? nn_sm_intro : no_sm_intro;
	  }
   render() {
    return (
      <>
        <p>
          <AudioPlayer autoplay inline src={this.audio} />
          {strings.sm_intro1}<br />
          {strings.sm_intro2}
        </p>
        <ReadyButton onReadyChange={this.props.setReady} />
      </>
    );
  }
}

export default IntroNonwords;
